import React from "react";
import { Handle, Position } from "@xyflow/react";
import { Box, Typography, IconButton, Chip } from "@mui/material";
import { Edit as EditIcon, Inventory2Outlined } from "@mui/icons-material";

const ProductNode = ({ data }) => {
  return (
    <Box
      sx={{
        position: "relative",
        padding: "20px",
        borderRadius: "16px",
        background: "#ffffff",
        border: "2px solid #3b82f6",
        minWidth: 280,
        boxShadow: "0 8px 24px rgba(59, 130, 246, 0.15)",
        transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
        "&:hover": {
          transform: "translateY(-4px)",
          boxShadow: "0 12px 32px rgba(59, 130, 246, 0.25)",
        },
      }}
    >
      {/* 상단 헤더 */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 2,
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Box
            sx={{
              width: 40,
              height: 40,
              borderRadius: "12px",
              background: "linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              boxShadow: "0 4px 12px rgba(59, 130, 246, 0.3)",
            }}
          >
            <Inventory2Outlined sx={{ color: "#fff", fontSize: 22 }} />
          </Box>
          <Chip
            label="완제품"
            size="small"
            sx={{
              bgcolor: "#eff6ff",
              color: "#1e40af",
              fontWeight: 600,
              fontSize: "0.75rem",
              height: 24,
            }}
          />
        </Box>
        <IconButton
          size="small"
          onClick={data.onEdit}
          sx={{
            bgcolor: "#f1f5f9",
            "&:hover": {
              bgcolor: "#e2e8f0",
              transform: "scale(1.1)",
            },
            transition: "all 0.2s",
          }}
        >
          <EditIcon fontSize="small" sx={{ color: "#64748b" }} />
        </IconButton>
      </Box>

      {/* 제품명 */}
      <Typography
        variant="h6"
        sx={{
          fontWeight: 700,
          fontSize: "1.1rem",
          color: "#0f172a",
          mb: 2,
          lineHeight: 1.3,
        }}
      >
        {data.label}
      </Typography>

      {/* 정보 섹션 */}
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 1,
          p: 1.5,
          bgcolor: "#f8fafc",
          borderRadius: "12px",
          border: "1px solid #e2e8f0",
        }}
      >
        {data.material_grouping && (
          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
            <Typography
              variant="caption"
              sx={{ color: "#64748b", fontSize: "0.8rem" }}
            >
              그룹
            </Typography>
            <Typography
              variant="caption"
              sx={{ color: "#334155", fontWeight: 600, fontSize: "0.8rem" }}
            >
              {data.material_grouping}
            </Typography>
          </Box>
        )}
        {data.safety_stock !== undefined && data.safety_stock !== null && (
          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
            <Typography
              variant="caption"
              sx={{ color: "#64748b", fontSize: "0.8rem" }}
            >
              안전재고
            </Typography>
            <Typography
              variant="caption"
              sx={{ color: "#334155", fontWeight: 600, fontSize: "0.8rem" }}
            >
              {data.safety_stock}
            </Typography>
          </Box>
        )}
        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
          <Typography
            variant="caption"
            sx={{ color: "#64748b", fontSize: "0.8rem" }}
          >
            BOM 항목
          </Typography>
          <Typography
            variant="caption"
            sx={{ color: "#334155", fontWeight: 600, fontSize: "0.8rem" }}
          >
            {data.bomCount}개
          </Typography>
        </Box>
      </Box>

      <Handle
        type="source"
        position={Position.Right}
        style={{
          background: "#3b82f6",
          width: 12,
          height: 12,
          border: "3px solid #ffffff",
          boxShadow: "0 2px 8px rgba(59, 130, 246, 0.4)",
        }}
      />
    </Box>
  );
};

export default ProductNode;
